<template>
  <div class="content">
    <form>
    <user_pay-form :datas="dataall"></user_pay-form>
    <sklad :datas="dataall"></sklad>
    <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.user_pay.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { User_payForm, Sklad, Paytype} from "@/pages";
export default {
  components: { User_payForm, Sklad, Paytype},
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: {datetime: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        staff_id: null,
        user_id: parseInt(localStorage.getItem("user_id")),
        current_total: 0,
        summa: 0,
        kassa_summa: 0,
        pay_type_id: 1,
        dollar_rate:0,
        comment: ""}
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved<2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  mounted() {
    this.Data();
    this.Sklad();
  },
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Ходимга тўлов" });
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/user_pay/id/" + self.$route.params.id)
        .then(function(response) {
          self.dataall = response.data;
          setTimeout(() => {
            self.watch = true;
          }, 100);
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  }
};
</script>
